module.exports = __webpack_public_path__ + "img/jpy.673acadd.svg";